export default __webpack_public_path__ + "static/014-0ff81bed47fa3276845f3bdd23a0449d.jpg";